import '@tencent/tpm-meeting/lib/ComHero/style';
import React, { useContext, useEffect } from 'react';
import styles from './index.module.scss';
// import { List } from '@tencent/tea-component';
import { Breadcrumb, List } from 'tdesign-react';
import classnames from 'classnames';
import ProductDetailContext from '../../context/ProductDetailContext';
import {
  IProductPackageNode,
  IProductVersion,
  PackageNodeTypeBaseline,
  PackageNodeTypePatch,
  PatchPageDetails,
  PatchPageList
} from '@/tpss/types';
import ProductPackageTypeSwitcher from '../ProductPackageTypeSwitcher';
import ProductPackageNodeDetails from '../ProductPackageNodeDetails';
import ProductPatchList from '../ProductPatchList';
import { useNavigate, useParams } from 'react-router-dom';

interface IProps {
  productVersionID: string;
  productCode: string;
  productVersions: IProductVersion[];
}
const ProductVersionDetail: React.FC<IProps> = ({
  productVersionID,
  productCode,
  productVersions
}) => {
  // const [packages, setPackages] = useState<ProductPackage[]>([]);

  const { id } = useParams();
  const navigate = useNavigate();
  const { chooseBaselinePackageNode } = useContext(ProductDetailContext);
  const { currentPatch } = useContext(ProductDetailContext);
  const { currentBaseline } = useContext(ProductDetailContext);
  const { currentProductVersion } = useContext(ProductDetailContext);
  const { currentSoftwareType } = useContext(ProductDetailContext);
  const { patchPage } = useContext(ProductDetailContext);
  const { setCurrentSoftwareType } = useContext(ProductDetailContext);
  const { setPatchPage } = useContext(ProductDetailContext);
  useEffect(() => {
    // choosePackageNode
  }, []);

  /**
   * 检查登录状态并记录下载行为
   * @param action 执行的具体操作函数
   * @returns Promise<void>
   */

  // const downloadData = [
  //   {
  //     filename: 'cvm-3.10.11.3-linux-x86_64.tar.gz',
  //     description: 'cvm-3.10.11.3-linux-x86_64.tar.gz',
  //     size: '1024M',
  //     md5: '1234567890',
  //     manipulate: '下载',
  //     index: 1
  //   },
  //   {
  //     filename: 'cvm-3.10.11.3-linux-arm64.tar.gz',
  //     description: 'cvm-3.10.11.3-linux-arm64.tar.gz',
  //     size: '1024M',
  //     md5: '1234567890',
  //     manipulate: '下载',
  //     index: 2
  //   }
  // ];

  // function getSelectedVersion() {
  //   if (!productVersions) {
  //     return null;
  //   }
  //   for (let i = 0; i < productVersions.length; i++) {
  //     if (numToStr(productVersions[i].ID) === productVersionID) {
  //       return productVersions[i];
  //     }
  //   }
  //   return null;
  // }

  function isBaselineSelecteed(baselineNode: IProductPackageNode) {
    if (currentBaseline === baselineNode.ProductPackageNodeName) {
      return true;
    }
    return false;
  }

  function getSingleBaseLineNode(baselineNode: IProductPackageNode) {
    return (
      <div
        key={baselineNode.ID}
        className={classnames([
          styles.baselineNode,
          isBaselineSelecteed(baselineNode) ? styles.baselineNodeSelected : ''
        ])}
        // className={styles.baselineNode}
        onClick={() => {
          navigate(`/product/${id}/package/${baselineNode.ID}`);
          setCurrentSoftwareType(PackageNodeTypeBaseline);
          chooseBaselinePackageNode(baselineNode);
        }}
      >
        {baselineNode.ProductPackageNodeName}
      </div>
    );
  }
  // function gotoDownloadTable() {
  //   // window.scrollTo({
  //   //   top: document.documentElement.scrollHeight,
  //   //   behavior: 'smooth'
  //   // });
  //   bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  //   // bottomRef.current?.scrollTop = bottomRef.current?.scrollHeight;
  // }

  function getPackageNodes() {
    const selectedVersion = currentProductVersion;
    // console.log('selectedVersion');
    // console.log(selectedVersion);
    if (!selectedVersion) {
      return;
    }
    // console.log('selectedVersion');
    // console.log(selectedVersion);
    const baselines: any[] = [];
    const packageNodes = selectedVersion.Nodes;
    if (packageNodes) {
      for (let i = 0; i < packageNodes.length; i++) {
        if (packageNodes[i].ProductPackageNodeType === 'baseline') {
          baselines.push(selectedVersion.Nodes[i]);
        }
      }
    }

    return (
      <div className={styles.softwareRoadmap}>
        <List>{baselines.map((baseline) => getSingleBaseLineNode(baseline))}</List>
      </div>
    );
  }
  const { BreadcrumbItem } = Breadcrumb;
  function breadcrumbNeedDisplay() {
    if (
      currentSoftwareType === PackageNodeTypePatch &&
      patchPage === PatchPageDetails
    ) {
      return true;
    }
    return false;
  }
  function goBackToPatchList() {
    setCurrentSoftwareType(PackageNodeTypePatch);
    setPatchPage(PatchPageList);
  }

  return (
    <div className={styles.softwareContaienr}>
      <div className={styles.contentWrapper}>
        {getPackageNodes()}
        <div className={styles.softwareDetails}>
          <ProductPackageTypeSwitcher />
          <Breadcrumb
            separator={'/'}
            style={{
              display: breadcrumbNeedDisplay() ? '' : 'none',
              marginTop: '15px'
            }}
          >
            <BreadcrumbItem onClick={() => goBackToPatchList()} maxItemWidth="200px">
              {currentBaseline} - 补丁包列表
            </BreadcrumbItem>
            <BreadcrumbItem
              className={styles.breadcrumbSecondLevel}
              maxItemWidth="200px"
            >
              {currentPatch}
            </BreadcrumbItem>
          </Breadcrumb>
          <ProductPatchList />
          <ProductPackageNodeDetails />
        </div>
      </div>
    </div>
  );
};

export default ProductVersionDetail;
